export type CheckIconProps = {
  size: number;
  isDisabled?: boolean;
};

export const CheckIcon = ({ isDisabled = false, size }: CheckIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect
        width={'100%'}
        height={'100%'}
        rx={'50%'}
        fill={
          isDisabled
            ? 'var(--mantine-color-gray-1'
            : 'var(--mantine-color-green-1'
        }
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4939 12.3167L16.5606 23.8334L13.3939 20.45C12.8106 19.9 11.8939 19.8667 11.2273 20.3334C10.5773 20.8167 10.3939 21.6667 10.7939 22.35L14.5439 28.45C14.9106 29.0167 15.5439 29.3667 16.2606 29.3667C16.9439 29.3667 17.5939 29.0167 17.9606 28.45C18.5606 27.6667 30.0106 14.0167 30.0106 14.0167C31.5106 12.4834 29.6939 11.1334 28.4939 12.3V12.3167Z"
        fill={
          isDisabled
            ? 'var(--mantine-color-gray-5'
            : 'var(--mantine-color-green-5'
        }
      />
    </svg>
  );
};
